import { t } from 'i18next';

const API_ERRORS: Record<string, () => string> = {
  'must-be-string': () => t('api-errors:must_be_string'),
  'must-be-number': () => t('api-errors:must_be_number'),
  'must-be-number-string': () => t('api-errors:must_be_number_string'),
  'must-be-hexadecimal': () => t('api-errors:must_be_hexadecimal'),
  'must-be-boolean': () => t('api-errors:must_be_boolean'),
  'must-be-boolean-string': () => t('api-errors:must_be_boolean_string'),
  'must-be-object': () => t('api-errors:must_be_object'),
  'must-be-array': () => t('api-errors:must_be_array'),
  'must-be-defined': () => t('api-errors:must_be_defined'),
  'must-be-in-enum': () => t('api-errors:must_be_in_enum'),
  'must-be-valid-date': () => t('api-errors:must_be_valid_date'),
  'must-be-plain-date': () => t('api-errors:must_be_plain_date'),
  'must-be-valid-uuid': () => t('api-errors:must_be_valid_uuid'),
  'must-be-valid-locale': () => t('api-errors:must_be_valid_locale'),
  'must-be-email': () => t('api-errors:must_be_email'),
  'string-too-long': () => t('api-errors:string_too_long'),
  'string-too-short': () => t('api-errors:string_too_short'),
  'number-too-big': () => t('api-errors:number_too_big'),
  'number-too-small': () => t('api-errors:number_too_small'),
  'array-must-not-be-empty': () => t('api-errors:array_must_not_be_empty'),
  'invalid-multilingual-label': () => t('api-errors:invalid_multilingual_label'),
  'invalid-content-status': () => t('api-errors:invalid_content_status'),
  'invalid-zones': () => t('api-errors:invalid_zones'),
  'invalid-cards': () => t('api-errors:invalid_cards'),
  'invalid-media': () => t('api-errors:invalid_media'),
  'invalid-campaign-session': () => t('api-errors:invalid_campaign_session'),
  'thematic-not-found': () => t('api-errors:thematic_not_found'),
  'image-not-found': () => t('api-errors:image_not_found'),
  'video-not-found': () => t('api-errors:video_not_found'),
  'no-correct-choice': () => t('api-errors:no_correct_choice'),
  'not-valid-length': () => t('api-errors:not_valid_length'),
  'invalid-cards-number': () => t('api-errors:invalid_cards_number'),
  'text-or-image-must-be-defined': () => t('api-errors:text_or_image_must_be_defined'),
};

function translateError(key: keyof typeof API_ERRORS): string {
  return API_ERRORS[key]();
}

type FieldName = string;

export type ErrorsKeys = { text: (keyof typeof API_ERRORS)[] } | (keyof typeof API_ERRORS)[];

export function translateApiErrors(errors?: Record<FieldName, ErrorsKeys>): string {
  if (!errors) return '';

  return Object.values(errors)
    .reduce((acc: string[], fieldErrorArray) => {
      if (Array.isArray(fieldErrorArray)) {
        return acc.concat(fieldErrorArray.map((errorKey: keyof typeof API_ERRORS) => translateError(errorKey)));
      }
      return acc.concat(fieldErrorArray.text.map((errorKey: keyof typeof API_ERRORS) => translateError(errorKey)));
    }, [])
    .join(', ');
}
